import React from "react";
import { X } from "lucide-react";
import { getPostTypeBorderColor } from "../../utils/postTypeUtils";

/**
 * PostTypeFilterSidebar - Post type filter buttons component
 * Displays post type filter buttons for filtering posts by type
 */
const PostTypeFilterSidebar = ({
	postTypes,
	postTypeFilters,
	togglePostTypeFilter,
	clearPostTypeFilters,
	hasActiveFilters,
}) => {
	return (
		<div className="rounded-lg border-2 border-purple-300 bg-white p-3 shadow-lg dark:border-purple-700 dark:bg-gray-800">
			<div className="mb-3 flex items-center justify-between">
				<h3 className="font-bold text-gray-900 dark:text-white">
					Filter Posts
				</h3>
				{hasActiveFilters ? (
					<button
						onClick={clearPostTypeFilters}
						className="text-xs text-purple-600 underline hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300"
					>
						Show All
					</button>
				) : null}
			</div>
			<div className="space-y-2">
				{postTypes.map((type) => {
					const Icon = type.icon;
					const isFiltered = postTypeFilters[type.id];
					return (
						<button
							key={type.id}
							onClick={() => togglePostTypeFilter(type.id)}
							className={`flex w-full items-center gap-3 rounded-lg border-2 p-3 transition-colors ${
								isFiltered
									? `${type.color} text-white ${getPostTypeBorderColor(type.id)}`
									: `bg-gray-200 text-gray-900 hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 ${getPostTypeBorderColor(type.id)}`
							}`}
						>
							<Icon size={20} />
							<div className="flex-1 text-left">
								<div className="font-medium">{type.label}</div>
							</div>
							{isFiltered ? (
								<X
									size={16}
									className="text-white opacity-80 hover:opacity-100"
									onClick={(e) => {
										e.stopPropagation();
										togglePostTypeFilter(type.id);
									}}
								/>
							) : null}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default PostTypeFilterSidebar;
